import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex); 

const state = {
    token: localStorage.getItem("access_token") || "",
    user : JSON.parse(localStorage.getItem("user")) || {},
    fullname: ""
}


const mutations = {
    SET_SESSION: (state) => {
      state.token = localStorage.getItem("access_token")
      
      let user = JSON.parse(localStorage.getItem("user"))
      if(user != null){
        state.user = user
          state.user.firstname =  state.user.firstname[0].toUpperCase() +  state.user.firstname.slice(1)
        if(state.user.lastname){
          state.user.lastname = state.user.lastname[0].toUpperCase() +  state.user.lastname.slice(1);
        }
        if(state.user.middlename){
          state.user.middlename = state.user.middlename[0].toUpperCase() +  state.user.middlename.slice(1);
        }
      }
    },
    LOGOUT: (state) =>{
      localStorage.clear();
      state.token = "";
      state.user = {};
    }
}

const actions = {

}

const getters = {

    FULLNAME: () => {
      if(state.user != null || state.user != ''){
        if(state.user){
          let fname =  state.user.firstname[0].toUpperCase() +  state.user.firstname.slice(1),

          lname,
          mname;

          if(state.user.lastname){
            lname = state.user.lastname[0].toUpperCase() +  state.user.lastname.slice(1);
          }
          if(state.user.middlename){
            mname = state.user.middlename[0].toUpperCase() +  state.user.middlename.slice(1);
          }

          let fullname = fname;
          if(mname != ''){
            fullname = fullname+' '+mname
          }
          fullname = fullname+' '+lname
          return fullname
        }
      }
    },
    ROLE: () => {
      let role = state.user.role[0]
      role = role[0].toUpperCase() +  role.slice(1)
      return role
    },

    USER: () => {
        return state.user
    },
    ISLOGGED: () => {
        if(state.token == "" || state.token == null){
          return false;
        }
        return true; 
    },
    TOKEN: () => {
      return state.token
    }
}

export default {
    state,getters,mutations,actions
}
    